import React from 'react';
import { connect } from 'react-redux';

// HOC to provide feature flag functionality to class components
export const withFeatureFlag = WrappedComponent => {
    const WithFeatureFlagComponent = props => {
        const { featuresStore, ...otherProps } = props;

        return (
            <WrappedComponent
                {...otherProps}
                featureFlag={{
                    ...featuresStore.features,
                    loading: featuresStore.loading,
                    error: featuresStore.error,
                }}
            />
        );
    };

    WithFeatureFlagComponent.displayName = `withFeatureFlag(${WrappedComponent.displayName ||
        WrappedComponent.name ||
        'Component'})`;

    const mapStateToProps = state => ({
        featuresStore: state.featuresStore,
    });

    return connect(mapStateToProps)(WithFeatureFlagComponent);
};
